<template>
    <div class="box">
        <div class="">
            <picture>
                <source media="(max-width: 767px)" width="750" height="880" type="image/webp"
                    srcset="~/assets/new-eng-landing/headbanner/banner_mob.webp">
                <source media="(max-width: 767px)" width="750" height="880" type="image/jpeg"
                    srcset="~/assets/new-eng-landing/headbanner/banner_mob.webp">
                <!-- <source media="(max-width: 767px)" width="767" height="349" type="image/jpeg" srcset="~/assets/new-eng-landing/banner/banner_mobile.webp"> -->

                <img alt="Discover handcrafted designs perfect for your special moment" width="3840" height="1100"
                    type="image/jpeg" src="~/assets/new-eng-landing/headbanner/banner.jpg">
            </picture>
        </div>

        <div class="text">
            <h1 class="font-active">Engagement Rings</h1>
            <span>Your perfect proposal starts here!</span>
        </div>

    </div>
</template>

<script setup>
   const localePath = useLocalePath();
</script>

<style scoped>


.box {
    overflow: hidden;
    position: relative;
}

h1 {
    font-size: 50px;
    color: #1a2738;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-shadow: 1px 1px 2px 0px #1A2738;

}

.text {
    position: absolute;
    bottom: 45%;
    right: 25%;
    transform: translate(45%, 10%);
}

.text span {
    color: #c07953;
    font-size: 18px;
    letter-spacing: 3px;
    text-transform: uppercase;
}

@media (max-width:992px) {
    h1 {
        font-size: 40px;
    }
    .text span {
        letter-spacing: 2px;
        font-size: 16px;
    }

}
@media (max-width:767px) {
    h1 {
        font-size: 36px;
        text-shadow: 2px 2px 0px black;
        color: #ffffff;
    }
    .text {
        bottom: 20%;
        right: 50%;
        width: 51%;
        transform: translate(10%, 40%);
    }
    .text span {
        letter-spacing: 1px;
        font-size: 14px;

    }

}
@media (max-width: 500px) {

}

</style>
